import dummy_agreements_response from 'mocks/serverResponses/agreements/dummy_agreements_response';

function get(req: any, res: any, ctx: any) {
	return res(ctx.json(dummy_agreements_response), ctx.status(200));
}

export default {
	get,
};
